import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { MenuService } from '../services/index.js';

export const useMenuStore = create(
  persist(
    (set, get) => ({
      selectedMenuId: null,
      menus: [],
      items: [],
      cart: [],
      isLoading: false,

      setSelectedMenu: (menuId) => {
        set({ selectedMenuId: menuId });
        // Fetch menu items when menu is selected
        get().fetchMenuItems(menuId);
      },

      addToCart: (item, quantity) => {
        const { cart } = get();
        const existingItemIndex = cart.findIndex(cartItem => cartItem.itemID === item.itemID);

        if (existingItemIndex >= 0) {
          const updatedCart = [...cart];
          updatedCart[existingItemIndex] = {
            ...updatedCart[existingItemIndex],
            quantity: updatedCart[existingItemIndex].quantity + quantity,
          };
          set({ cart: updatedCart });
        } else {
          const cartItem = {
            itemID: item.itemID,
            Product_ID: item.Product_ID || item.itemID,
            name: item.name,
            price: item.price,
            quantity: quantity,
          };
          set({ cart: [...cart, cartItem] });
        }
      },

      decrementFromCart: (itemId) => {
        const { cart } = get();
        const existingItem = cart.find(item => item.itemID === itemId);

        if (!existingItem) return;

        if (existingItem.quantity <= 1) {
          // Remove item completely
          set({ cart: cart.filter(item => item.itemID !== itemId) });
        } else {
          const updatedCart = cart.map(item =>
            item.itemID === itemId
              ? { ...item, quantity: item.quantity - 1 }
              : item
          );
          set({ cart: updatedCart });
        }
      },

      removeFromCart: (itemId) => {
        const { cart } = get();
        const updatedCart = cart.filter(item => item.itemID !== itemId);
        set({ cart: updatedCart });
      },

      clearCart: () => {
        set({ cart: [] });
      },

      fetchMenus: async (outletId) => {
        set({ isLoading: true });
        try {
          const menus = await MenuService.fetchMenus(outletId);
          const currentSelected = get().selectedMenuId;

          set({
            menus,
            isLoading: false,
            // Auto-select primary menu or first menu if none selected
            selectedMenuId: currentSelected ||
              menus.find(m => m.is_primary_menu === 'yes')?.menu_id ||
              (menus.length > 0 ? menus[0].menu_id : null),
          });

          // Fetch items for the selected menu
          const selectedId = get().selectedMenuId;
          if (selectedId) {
            get().fetchMenuItems(selectedId);
          }
        } catch (error) {
          console.error('Error fetching menus:', error);
          set({ isLoading: false });
        }
      },

      fetchMenuItems: async (menuId) => {
        set({ isLoading: true });
        try {
          const items = await MenuService.fetchMenuItems(menuId);
          set({
            items,
            isLoading: false,
          });
        } catch (error) {
          console.error('Error fetching menu items:', error);
          set({ items: [], isLoading: false });
        }
      },
    }),
    {
      name: 'menu-storage',
      partialize: (state) => ({
        selectedMenuId: state.selectedMenuId,
        cart: state.cart,
      }),
    }
  )
);
